class TranslationService {
  static instance = null;

  static getInstance() {
    if (!TranslationService.instance) {
      TranslationService.instance = new TranslationService();
    }
    return TranslationService.instance;
  }

  constructor() {
    if (TranslationService.instance) return TranslationService.instance;
    this.currentLang = 'es';
    this.cache = {};
    this.modules = {};
    this.listeners = new Set();
    TranslationService.instance = this;
  }

  getLang() { return this.currentLang; }

  async setLang(lang, modules) {
    this.currentLang = lang;
    this.cache[lang] = this.cache[lang] || {};
    const toLoad = modules.filter(m => !this.cache[lang][m]);
    if (toLoad.length > 0) {
      await Promise.all(toLoad.map(m => this.loadModule(lang, m)));
    }
    this.modules[lang] = modules;
    this.notify();
  }

  async addModules(lang, modules) {
    this.cache[lang] = this.cache[lang] || {};
    const toLoad = modules.filter(m => !this.cache[lang][m]);
    if (toLoad.length > 0) {
      await Promise.all(toLoad.map(m => this.loadModule(lang, m)));
    }
  }

  async loadModule(lang, module) {
    try {
      const resp = await fetch(`/lang/${lang}/${module}.json`);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      this.cache[lang][module] = await resp.json();
    } catch (e) {
      console.warn(`[TranslationService] Error loading /lang/${lang}/${module}.json:`, e);
      this.cache[lang][module] = {};
    }
  }

  t(key) {
    const current = this.cache[this.currentLang];
    if (current) {
      for (const mod of Object.keys(current)) {
        if (current[mod][key] !== undefined) return current[mod][key];
      }
    }
    const fallback = this.cache['es'];
    if (fallback) {
      for (const mod of Object.keys(fallback)) {
        if (fallback[mod][key] !== undefined) return fallback[mod][key];
      }
    }
    return key;
  }

  tWithVars(key, vars) {
    let text = this.t(key);
    if (text && vars) {
      Object.keys(vars).forEach(k => {
        text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), vars[k]);
      });
    }
    return text;
  }

  onChange(fn) { this.listeners.add(fn); }
  offChange(fn) { this.listeners.delete(fn); }
  notify() { this.listeners.forEach(fn => fn(this.currentLang)); }
}

if (typeof window !== 'undefined') {
  window.TranslationService = TranslationService;
}

export default TranslationService;
